// src/components/WhyChoose/WhyChoose.js

import React from "react";
import "./Whychooseus.css";
import logo from "../../assests/logo.jpeg";

import {
  FaClipboardList,
  FaMicroscope,
  FaCapsules,
  FaAppleAlt,
  FaLaptopMedical,
  FaUserGraduate
} from "react-icons/fa";

function WhyChoose() {
  const features = [
    {
      icon: <FaClipboardList />,
      color: "#2E7D32",
      title: "Treatment & Consultation",
      desc: "Personalized care plans based on your symptoms and health history.",
    },
    {
      icon: <FaMicroscope />,
      color: "#6A1B9A",
      title: "Diagnosis",
      desc: "Understanding root causes through detailed case analysis.",
    },
    {
      icon: <FaCapsules />,
      color: "#E53935",
      title: "Safe Natural Remedies",
      desc: "Gentle treatments focused on long-term healing.",
    },
    {
      icon: <FaAppleAlt />,
      color: "#FB8C00",
      title: "Diet Guidance",
      desc: "Lifestyle and nutrition suggestions for better recovery.",
    },
    {
      icon: <FaLaptopMedical />,
      color: "#1565C0",
      title: "Online Consultation",
      desc: "Easy virtual appointments from the comfort of your home.",
    },
    {
      icon: <FaUserGraduate />,
      color: "#00897B",
      title: "Health Education",
      desc: "Awareness and guidance to help you stay healthy.",
    },
  ];

  return (
    <section className="why-section">
      <div className="why-container">

        <div className="why-left">

          {/* <p className="why-tag">WHY CHOOSE ROOTLY</p> */}

          <h2>
            Why Choose <br />
            Rootly Homoeopathy
          </h2>

          <div className="why-grid">

            {features.map((item, index) => (
              <div className="why-card" key={index}>

                <div
                  className="why-icon"
                  style={{
                    color: item.color,
                    background: "#ffffff",
                    boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
                    border: `2px solid ${item.color}20`
                  }}
                >
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>
            ))}

          </div>

        </div>

        <div className="why-right">
          <img
            src={logo}
            alt="Rootly Homoeopathy"
            className="why-image"
          />
        </div>

      </div>
    </section>
  );
}

export default WhyChoose;